import React from 'react';
import { fmtCurrencyPrecise } from '../cashReserves/helpers';

const cardStyle = {
  borderLeftWidth: '4px',
  borderLeftStyle: 'solid',
  height: '100%',
};

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gridTemplateRows: 'repeat(2, minmax(0, 1fr))',
  gap: '0.5rem',
  width: '100%',
  height: '100%',
};

const TransactionSummaryCards = ({ metrics, className = '' }) => {
  const cards = [
    {
      key: 'deposits',
      label: 'Total Deposits',
      value: metrics.deposits,
      color: '#198754',
      textClass: 'text-success',
    },
    {
      key: 'withdrawals',
      label: 'Total Withdrawals',
      value: metrics.withdrawals,
      color: '#dc3545',
      textClass: 'text-danger',
    },
    {
      key: 'managementFees',
      label: 'Total Management Fees',
      value: metrics.managementFees,
      color: '#fd7e14',
      textClass: 'text-warning',
    },
    {
      key: 'netTransactions',
      label: 'Net Transactions',
      value: metrics.netTransactions,
      color: '#0d6efd',
      textClass: metrics.netTransactions >= 0 ? 'text-success' : 'text-danger',
    },
  ];

  return (
    <div className={className} style={gridStyle}>
      {cards.map((card) => (
        <div
          key={card.key}
          className="card"
          style={{ ...cardStyle, borderLeftColor: card.color }}
        >
          <div className="card-body py-2 px-3 h-100 d-flex flex-column justify-content-center">
            <div
              className="text-muted"
              style={{ fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}
            >
              {card.label}
            </div>
            <div className={`fw-bold ${card.textClass}`} style={{ fontSize: '1.25rem' }}>
              {fmtCurrencyPrecise(card.value)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TransactionSummaryCards;
